import { LineState } from "../../../types";

export interface EntryLine {
  id: string;
  quantity: number;
  showQuantityWarning: boolean;
  quantityWarningMessage: string;
  partNumber: string;
  showPartNumberWarning: boolean;
  partNumberWarningMessage: string;
  state: LineState;
  bin: string;
  action: boolean;
  isEdited: boolean;
  isNew?: boolean;
  isValidated: boolean;
  showPartNumberInfo: boolean;
  uniqueLineId?: string;
  engineSerialNumber?: string[];
  showSerialNumberField: boolean;
  showSerialNumberWarning: boolean;
  serialNumberWarningMessage: string;
}

export interface LineValidationState {
  isQuantityValid: boolean;
  quantityFailureMessage: string;
  isPartNumberValid: boolean;
  partNumberFailureMessage: string;
  showPartNumberInfo: boolean;
  requiresSerialNumber: boolean;
  isSerialNumberValid: boolean;
  serialNumberFailureMessage: string;
}

export interface ValidationState {
  isValid: boolean;
  description: string;
}

export interface ValidationType {
  category: string;
  status: string;
  description: string;
  upstreamHttpStatus?: string;
}

export interface CsvRowType {
  PartNumber: string;
  Quantity: string;
  Bin: string;
  EngineSerialNumber?: string;
}

export interface OrderEntryRows {
  partNumber: string;
  quantity: number;
  bin: string;
  engineSerialNumber?: string[];
}

export enum ValidationStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  UNABLE_TO_DETERMINE = "UNABLE_TO_DETERMINE",
}

export enum ValidationCategory {
  QUANTITY_VALIDATION = "QUANTITY_VALIDATION",
  PACKAGE_QUANTITY_VALIDATION = "PACKAGE_QUANTITY_VALIDATION",
  PART_NUMBER_VALIDATION = "PART_NUMBER_VALIDATION",
  GEO_RESTRICT_VALIDATION = "GEO_RESTRICT_VALIDATION",
  PROMOTION_VALIDATION = "PROMOTION_VALIDATION",
  PRODUCT_FOR_SERVICE_VALIDATION = "PRODUCT_FOR_SERVICE_VALIDATION",
  PRODUCT_EFFECTIVE_VALIDATION = "PRODUCT_EFFECTIVE_VALIDATION",
  PRODUCT_NOT_OBSOLETE_VALIDATION = "PRODUCT_NOT_OBSOLETE_VALIDATION",
  LISTING_AND_FENCING_VALIDATION = "LISTING_AND_FENCING_VALIDATION",
  TAX_LAW_VALIDATION = "TAX_LAW_VALIDATION",
  PRODUCT_NOT_HELD_FOR_REVIEW_VALIDATION = "PRODUCT_NOT_HELD_FOR_REVIEW_VALIDATION",
  REFERENCE_PRICE_VALIDATION = "REFERENCE_PRICE_VALIDATION",
  HARMONIZED_CODE_VALIDATION = "HARMONIZED_CODE_VALIDATION",
  PARTS_SPECIFICATION_VALIDATION = "PARTS_SPECIFICATION_VALIDATION",
  ACCOUNT_ADDRESS_VALIDATION = "ACCOUNT_ADDRESS_VALIDATION",
  ORDER_VALUE_CREDIT_CHECK_VALIDATION = "ORDER_VALUE_CREDIT_CHECK_VALIDATION",
  MAX_LINE_VALUE_VALIDATION = "MAX_LINE_VALUE_VALIDATION",
  PART_NOT_HAZARDOUS_VALIDATION = "PART_NOT_HAZARDOUS_VALIDATOR",
  PART_SERIAL_NUMBER_REQ_VALIDATION = "PART_SERIAL_NUMBER_REQ_VALIDATOR",
  ENGINE_SERIAL_NUMBER_PROVIDED_VALIDATION = "ENGINE_SERIAL_NUMBER_PROVIDED_VALIDATOR",
}

export const LineValidationCategoryPriorityOrder = [
  ValidationCategory.QUANTITY_VALIDATION,
  ValidationCategory.PART_NUMBER_VALIDATION,
  ValidationCategory.PROMOTION_VALIDATION,
  ValidationCategory.PRODUCT_FOR_SERVICE_VALIDATION,
  ValidationCategory.PRODUCT_EFFECTIVE_VALIDATION,
  ValidationCategory.PRODUCT_NOT_OBSOLETE_VALIDATION,
  ValidationCategory.LISTING_AND_FENCING_VALIDATION,
  ValidationCategory.TAX_LAW_VALIDATION,
  ValidationCategory.PART_NOT_HAZARDOUS_VALIDATION,
  ValidationCategory.PART_SERIAL_NUMBER_REQ_VALIDATION,
  ValidationCategory.ENGINE_SERIAL_NUMBER_PROVIDED_VALIDATION,
];

export const LineInvestigationCategoryPriorityOrder = [
  ValidationCategory.PRODUCT_NOT_HELD_FOR_REVIEW_VALIDATION,
  ValidationCategory.REFERENCE_PRICE_VALIDATION,
  ValidationCategory.HARMONIZED_CODE_VALIDATION,
  ValidationCategory.PARTS_SPECIFICATION_VALIDATION,
];

export const DealerInvestigationMaximumLineValueValidation =
  ValidationCategory.MAX_LINE_VALUE_VALIDATION;
